import { render, staticRenderFns } from "./FeedBackWriteForm.vue?vue&type=template&id=a30ba63e&scoped=true&"
import script from "./FeedBackWriteForm.vue?vue&type=script&lang=js&"
export * from "./FeedBackWriteForm.vue?vue&type=script&lang=js&"
import style0 from "./FeedBackWriteForm.vue?vue&type=style&index=0&id=a30ba63e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a30ba63e",
  null
  
)

export default component.exports